import * as React from 'react';
import Card from '../../sharedComponents/core/Cards/Card';
import FancyInput from './FancyInput';
import FancyButton from './FancyButton';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from 'helpers/theme';
import { ReactComponent as Logo } from '../../assets/logo/ttc-logo.svg';

const useStyles = createUseStyles((theme: Theme) => ({
  loginDialogueRoot: {},
  root: {
    display: 'flex',
    width: 378,
    flexDirection: 'column',
    background: 'white'
  },
  logoContainer: {
    padding: [30, 0, 20]
  },
  logo: {
    height: 51
  },
  heading: {
    fontWeight: 800,
    color: theme.colors.primaryBlack
  },
  subheading: {
    color: theme.colors.textGrey,
    fontWeight: 300,
    fontSize: 15,
    marginTop: 0,
    marginBottom: theme.spacing(2)
  },
  link: {
    cursor: 'pointer',
    margin: '22px 0 19px 0',
    textAlign: 'center',
    color: theme.colors.textBlue,
    fontSize: theme.fontSizes.small
  },
  errMessage: {
    color: '#43454a',
    fontWeight: 200,
    fontSize: 15,
    textAlign: 'center',
    margin: 3
  },
  toolTipContainer: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    filter: 'drop-shadow(5px 5px 2px rgba(0,0,0,0.15))',
    transform: 'translateY(-42%)',
    marginLeft: 50
  },
  toolTip: {
    position: 'relative',
    right: 50,
    width: '325px',
    boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
    borderRadius: '5px',
    padding: '15px',
    backgroundColor: theme.colors.primaryWhite,
    fontSize: theme.fontSizes.small,
    fontWeight: '400',
    lineHeight: '15px'
  },
  triangle: {
    zIndex: 1,
    position: 'relative',
    width: 0,
    height: 0,
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderTop: `20px solid ${theme.colors.primaryWhite}`,
    marginBottom: '130px'
  }
}));

type Props = {
  sent: boolean;
  onBack: () => void;
  onSubmit: (email: string, errorCallback: (err: string) => void) => void;
};

function PasswordDialogue({ sent, onBack, onSubmit }: Props) {
  const theme = useTheme();
  const classes = useStyles({ theme });

  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState('');
  const onRecover = () => {
    onSubmit(email, (err) => {
      setError(err);
      if (err.includes('delegate')) {
        setOpenTooltip(true);
      }
    });
  };
  const [openTooltip, setOpenTooltip] = React.useState(false);

  return (
    <div className={classes.loginDialogueRoot}>
      <Card padding="medium" className={classes.root}>
        <div className={classes.logoContainer}>
          <Logo className={classes.logo} />
        </div>
        <h1 className={classes.heading}>Password recovery</h1>
        {!sent && (
          <p className={classes.subheading}>
            Please enter your e-mail address below to recover your password
          </p>
        )}
        <p className={classes.errMessage}>
          {error.includes('delegate') ? '' : error}
        </p>
        <form
          onSubmit={(evt) => {
            evt.preventDefault();
            onRecover();
          }}
        >
          {sent ? (
            <p className={classes.subheading}>
              A link has been sent to the email you entered, follow the
              instructions to reset your password
            </p>
          ) : (
            <>
              <FancyInput
                label="Email"
                labelColor={'#5CC301'}
                type={'text'}
                onChange={setEmail}
              />
              <div>
                {openTooltip && (
                  <div className={classes.toolTipContainer}>
                    <span className={classes.toolTip}>
                      <strong>Trying to reset your password?</strong> Please
                      contact your manager to help you recover your password.
                    </span>
                    <div className={classes.triangle} />
                  </div>
                )}
                <FancyButton text={'Recover password'} />
              </div>
            </>
          )}
        </form>
        <a className={classes.link} onClick={onBack}>
          Back
        </a>
      </Card>
    </div>
  );
}

export default PasswordDialogue;
